"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _ramda = require("ramda");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var env = process.env || {
  NODE_ENV: undefined
};
var NODE_ENV = env.NODE_ENV;
var isTest = NODE_ENV === 'test';
var allChars = (0, _ramda.split)('', 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789');
var serializeLabel = function serializeLabel(str) {
  return str.replace(/\s/gi, '__');
};
var shuffler = (0, _ramda.curry)(function (random, list) {
  var idx = -1;
  var position;
  var len = list.length;
  var result = [];
  while (++idx < len) {
    position = Math.floor((idx + 1) * random());
    result[idx] = result[position];
    result[position] = list[idx];
  }
  return result;
});
var shuffle = shuffler(Math.random);
/**
 * useLabelPrefix
 * @param {string} label input to be prefixed
 * @param {number} length the length of the prefix
 */

var useLabelPrefix = function useLabelPrefix(label) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var takeLength = (0, _react.useMemo)(function () {
    return (0, _ramda.take)(length);
  }, [length]);
  var prefix = (0, _ramda.pipe)(shuffle, takeLength, (0, _ramda.join)(""))(allChars);
  var _useState = (0, _react.useState)("p_".concat(isTest ? '' : prefix, "_").concat(serializeLabel(label))),
    _useState2 = _slicedToArray(_useState, 1),
    prefixed = _useState2[0];
  return prefixed;
};
var _default = useLabelPrefix;
exports["default"] = _default;